import { Box, ButtonBase, Paper, Stack, Typography } from "@mui/material";
import NotificationButton from "./NotificationButton";
import TitleWithLogo from "../molecules/TitleWithLogo";
import MenuButton from "../atoms/MenuButton";
import { sideBarWidth } from "./SideBar";
import { useGlobalContext } from "../../stores/Global";
import useBreakpoint from "../../hooks/useBreakpoint";
import LanguageSwitcher from "../molecules/LanguageSwitcher";
import AccountPopover from "../molecules/AccountPopover";
import { useRef, useState } from "react";
import AvatarWithInitials from "../atoms/AvatarWithInitials";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export default function TopBar() {
  const { context, setContext } = useGlobalContext();
  const breakpoint = useBreakpoint();
  const anchorEl = useRef<any>(null);
  const [open, setOpen] = useState(false);

  return (
    <Box
      component={Paper}
      borderRadius={0}
      display="flex"
      boxShadow="0px 2px 6px 0px #0000000D"
      alignItems="center"
      p={2}
      boxSizing="border-box"
      bgcolor="background.default"
      id="g-topbar"
      zIndex={1250}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        boxSizing="border-box"
        pr={4}
        width={breakpoint.md ? sideBarWidth : 30}
      >
        {breakpoint.md && <TitleWithLogo />}
        {!breakpoint.md && (
          <MenuButton
            onClick={() =>
              setContext({ ...context, sidebar: !context.sidebar })
            }
          />
        )}
      </Box>
      <Box display="flex" justifyContent="center" flexGrow={1}>
        {!breakpoint.md && <TitleWithLogo />}
      </Box>
      <Stack spacing={2} direction="row" alignItems="center" sx={{ mr: 1 }}>
        <NotificationButton />
        <ButtonBase onClick={() => setOpen(true)} ref={anchorEl}>
          <Stack spacing={2} direction="row" alignItems="center">
            <AvatarWithInitials size={30}>
              {context.user?.name || ""}
            </AvatarWithInitials>
          </Stack>
        </ButtonBase>
      </Stack>
      <AccountPopover
        open={open}
        anchorEl={anchorEl.current}
        onClose={() => setOpen(false)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{ mt: 2 }}
      />
    </Box>
  );
}
